import {
    CATEGORY_ARTICLE_LIST_DATA,
    ARTICLE_DETAILS_DATA,
    ARTICLE_LIST_DATA,
    ADD_CATEGORY_ARTICLE_DATA,
    LOAD_CATEGORY_ARTICLE_DATA_DETAIL,
    UPDATE_CATEGORY_ARTICLE_DATA,
    ADD_CATEGORY_ARTICLE_S3_DATA,
 
} from './Constants'


//For category article list
const loadCategoryArticleListDataRequest = () => ({
  type: CATEGORY_ARTICLE_LIST_DATA.CATEGORY_ARTICLE_LIST_DATA_LOAD,
});
const setCategoryArticleListDataSuccess = (categoryArticleList) => ({
  type: CATEGORY_ARTICLE_LIST_DATA.CATEGORY_ARTICLE_LIST_DATA_SUCCESS,
  categoryArticleList,
});
const setCategoryArticleListDataFail = (error) => ({
  type: CATEGORY_ARTICLE_LIST_DATA.CATEGORY_ARTICLE_LIST_DATA_FAIL,
  error,
});

//For get article list with search
const loadArticleListDataRequest = (search = "") => ({
    type: ARTICLE_LIST_DATA.GET_ARTICLES_REQUEST,
    search,
});
const setArticleListDataSuccess = (articles) => ({
    type: ARTICLE_LIST_DATA.GET_ARTICLES_SUCCESS,
    articles,
});
const setArticleListDataFail = (error) => ({
    type: ARTICLE_LIST_DATA.GET_ARTICLES_FAILURE,
    error,
});

 const loadArticleDetailsRequest = (id) => ({
  type: ARTICLE_DETAILS_DATA.GET_ARTICLE_DETAILS_REQUEST,
  id,
});

 const setArticleDetailsSuccess = (data) => ({
  type: ARTICLE_DETAILS_DATA.GET_ARTICLE_DETAILS_SUCCESS,
  data,
});

 const setArticleDetailsFail = (error) => ({
  type: ARTICLE_DETAILS_DATA.GET_ARTICLE_DETAILS_FAILURE,
  error,
});
//For add article
const loadCategoryArticleAddDataRequest = (request) => ({
  type: ADD_CATEGORY_ARTICLE_DATA.ADD_CATEGORY_ARTICLE_DATA_LOAD,
  request,
});
const   setCategoryArticleAddDataSuccess = (categoryform) => ({
  type: ADD_CATEGORY_ARTICLE_DATA.ADD_CATEGORY_ARTICLE_DATA_SUCCESS,
  categoryform,
});
const setCategoryArticleAddDataFail = (error) => ({
  type: ADD_CATEGORY_ARTICLE_DATA.ADD_CATEGORY_ARTICLE_DATA_FAIL,
  error,
});
const setCategoryArticleAddDataReset = () => ({
  type: ADD_CATEGORY_ARTICLE_DATA.ADD_CATEGORY_ARTICLE_DATA_RESET,
});

//For get article detail
const loadCategoryArticleDetailDataRequest = (id) => ({
  type: LOAD_CATEGORY_ARTICLE_DATA_DETAIL.LOAD_CATEGORY_ARTICLE_DATA_DETAIL_LOAD,
  id,
});
const setCategoryArticleDetailDataSuccess = (categoryarticleDetail) => ({
  type: LOAD_CATEGORY_ARTICLE_DATA_DETAIL.LOAD_CATEGORY_ARTICLE_DATA_DETAIL_SUCCESS,
  categoryarticleDetail,
});

const setCategoryArticleDetailDataFail = (error) => ({
  type: LOAD_CATEGORY_ARTICLE_DATA_DETAIL.LOAD_CATEGORY_ARTICLE_DATA_DETAIL_FAIL,
  error,
});

// Update article request
 const loadCategoryArticleUpdateDataRequest = (id, request) => ({
  type: UPDATE_CATEGORY_ARTICLE_DATA.UPDATE_CATEGORY_ARTICLE_DATA_LOAD,
  id,
  request
});

// Success
 const setCategoryArticleUpdateDataSuccess = (category) => ({
  type: UPDATE_CATEGORY_ARTICLE_DATA.UPDATE_CATEGORY_ARTICLE_DATA_SUCCESS,
  category
});

// Fail
 const setCategoryArticleUpdateDataFail = (error) => ({
  type: UPDATE_CATEGORY_ARTICLE_DATA.UPDATE_CATEGORY_ARTICLE_DATA_FAIL,
  error
});

// Reset
 const setCategoryArticleUpdateDataReset = () => ({
  type: UPDATE_CATEGORY_ARTICLE_DATA.UPDATE_CATEGORY_ARTICLE_DATA_RESET
});

//For add article into s3
const loadCategoryArticleAddS3DataRequest = (request) => ({
  type: ADD_CATEGORY_ARTICLE_S3_DATA.ADD_CATEGORY_ARTICLE_S3_DATA_LOAD,
  request,
});
const   setCategoryArticleAddS3DataSuccess = (s3Url) => ({
  type: ADD_CATEGORY_ARTICLE_S3_DATA.ADD_CATEGORY_ARTICLE_S3_DATA_SUCCESS,
  s3Url,
});
const setCategoryArticleAddS3DataFail = (error) => ({
  type: ADD_CATEGORY_ARTICLE_S3_DATA.ADD_CATEGORY_ARTICLE_S3_DATA_FAIL,
  error,
});
const setCategoryArticleAddS3DataReset = () => ({
  type: ADD_CATEGORY_ARTICLE_S3_DATA.ADD_CATEGORY_ARTICLE_S3_DATA_RESET,
});

export {
    loadArticleListDataRequest,setArticleListDataSuccess,setArticleListDataFail,
    loadArticleDetailsRequest,setArticleDetailsSuccess,setArticleDetailsFail,
    loadCategoryArticleAddDataRequest, setCategoryArticleAddDataFail, setCategoryArticleAddDataSuccess,setCategoryArticleAddDataReset,
    loadCategoryArticleDetailDataRequest, setCategoryArticleDetailDataFail, setCategoryArticleDetailDataSuccess,
    loadCategoryArticleUpdateDataRequest, setCategoryArticleUpdateDataFail, setCategoryArticleUpdateDataSuccess,setCategoryArticleUpdateDataReset,
    loadCategoryArticleAddS3DataRequest, setCategoryArticleAddS3DataSuccess ,setCategoryArticleAddS3DataFail, setCategoryArticleAddS3DataReset,    
    loadCategoryArticleListDataRequest, setCategoryArticleListDataSuccess, setCategoryArticleListDataFail,

}